import React from 'react'
import classNames from 'classnames'
import * as styles from './SidebarLayout.less'

export default function SidebarLayout({ children, className, ...restProps }) {
  return (
    <div className={classNames(styles.sideContainer, className)} {...restProps}>
      {children}
    </div>
  )
}

export function Segment({ children, className, ...restProps }) {
  return (
    <div className={classNames(styles.segment, className)} {...restProps}>
      {children}
    </div>
  )
}
